// export const base = 'heading';

export const variant = {
  xl: 'text-heading-xl sm:text-heading-xl-sm md:text-heading-xl-md xl:text-heading-xl-xl',
  l: 'text-heading-l sm:text-heading-l-sm md:text-heading-l-md xl:text-heading-l-xl',
  m: 'text-heading-m sm:text-heading-m-sm md:text-heading-m-md xl:text-heading-m-xl',
  s: 'text-heading-s sm:text-heading-s-sm md:text-heading-s-md xl:text-heading-s-xl',
  xs: 'text-heading-xs sm:text-heading-xs-sm md:text-heading-xs-md xl:text-heading-xs-xl',
};
